var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIBotNav03({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.843 2.59961H7.15705C5.41745 2.59961 4 4.00632 4 5.74592V18.2345C4 19.9741 5.40671 21.3808 7.15705 21.3808H16.843C18.5825 21.3808 20 19.9741 20 18.2345V5.74592C20 4.00632 18.5933 2.59961 16.843 2.59961ZM16.4671 11.8238H7.53289C7.09262 11.8238 6.72752 11.4587 6.72752 11.0184C6.72752 10.5781 7.09262 10.213 7.53289 10.213H16.4671C16.9074 10.213 17.2725 10.5781 17.2725 11.0184C17.2725 11.4587 16.9074 11.8238 16.4671 11.8238ZM16.4671 7.87209H7.53289C7.09262 7.87209 6.72752 7.50699 6.72752 7.06672C6.72752 6.62645 7.09262 6.26135 7.53289 6.26135H16.4671C16.9074 6.26135 17.2725 6.62645 17.2725 7.06672C17.2725 7.50699 16.9074 7.87209 16.4671 7.87209Z",
    fill: "#5697FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBotNav03);
export default __webpack_public_path__ + "static/media/i_bot_nav_03.683495ff71366607fecb3421203d5815.svg";
export { ForwardRef as ReactComponent };